import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import { hide, show } from "./Helpers/animations";

let debounce: number | null = null;
const calendarElement: HTMLDivElement | null = document.getElementById('calendar') as HTMLDivElement | null;
const pageId: string =  (document.querySelector('meta[name=pageID]') as HTMLMetaElement | null)?.content ?? '';
const listView: HTMLDivElement | null = document.getElementById('listViewEvents') as HTMLDivElement | null;
const calendarView: HTMLDivElement | null = document.getElementById('calendarViewEvents') as HTMLDivElement | null;
const calendarViewTypeFilterContainer = document.getElementById('calendarViewTypeFilter');
const listViewTypeFilterContainer = document.getElementById('listViewTypeFilter');
const listViewYearFilterContainer = document.getElementById('listViewYearFilter');
const calendarViewTypeFilter: HTMLSelectElement | null = document.querySelector('#calendarViewTypeFilter select');
const viewToggleContainer: HTMLDivElement | null = document.querySelector('.filters-events .toggle-view') as HTMLDivElement | null;
let calendar: Calendar | null = null;

if (calendarElement) {
    calendar = new Calendar(calendarElement, {
        initialView: 'dayGridMonth',
        headerToolbar: { end: 'today prevYear prev next nextYear' },
        events: (info, success, failure) => {
            if (debounce) { clearTimeout(debounce); }
            debounce = setTimeout(async () => {
                const url = new URL(`${window.location.origin}${calendarElement.dataset?.endpoint ?? ''}`);
                url.searchParams.append('pageId', pageId);
                url.searchParams.append('start', info.startStr);
                url.searchParams.append('end', info.endStr);
                if (calendarViewTypeFilter && calendarViewTypeFilter.value) {
                    url.searchParams.append('type', calendarViewTypeFilter.value);
                }

                try {
                    const response = await fetch(url.href , { method: 'GET' });
                    if (response?.status === 200) {
                        const data = await response.json();
                        success(data);
                        const fcLinks = document.querySelectorAll('.fc-more-link');
                        fcLinks.forEach(fcLink => fcLink.addEventListener('click', handleFcMoreClick));
                    } else {
                        failure(new Error('Failed to load events'));
                    }
                } catch {
                    failure(new Error('Failed to load events'));
                }
            }, 200);
        },
        eventBackgroundColor: "#FAFAFA",
        eventBorderColor: "#BBB",
        eventTextColor: "#176272",
        eventDisplay: "block",
        displayEventTime: true,
        displayEventEnd: true,
        eventTimeFormat: {
            hour: "numeric",
            minute: "2-digit",
            meridiem: true
        },        
        contentHeight: "auto",
        dayMaxEvents: 3,
        plugins: [dayGridPlugin]
    });

    calendarViewTypeFilter?.addEventListener('change', () => {
        calendar?.refetchEvents();
    });
}

if (viewToggleContainer && listView && calendarView) {
    const listViewToggle: HTMLButtonElement | null = viewToggleContainer.querySelector('button:first-of-type');
    const calendarViewToggle: HTMLButtonElement | null = viewToggleContainer.querySelector('button:last-of-type');

    if (listViewToggle && calendarViewToggle) {
        window.addEventListener('resize', () => {
            if (window.innerWidth < 767 && window.getComputedStyle(calendarView).display !== 'none') {
                listViewToggle.ariaExpanded = 'true';
                listViewToggle.classList.add('on');
                calendarViewToggle.ariaExpanded = 'false';
                calendarViewToggle.classList.remove('on');
                
                hide(calendarView);
                hide(calendarViewTypeFilterContainer);
                show(listViewTypeFilterContainer);
                show(listViewYearFilterContainer);
                show(listView);

                document.documentElement.style.removeProperty('overflow-y');
            }
        });
    }

    if (calendarViewToggle && listViewToggle) {
        calendarViewToggle?.addEventListener('click', () => {
            if (calendarViewToggle.ariaExpanded !== 'true') {
                calendarViewToggle.ariaExpanded = 'true';
                calendarViewToggle.classList.add('on');

                listViewToggle.ariaExpanded = 'false';
                listViewToggle.classList.remove('on');

                hide(listView);
                show(calendarView);

                calendar?.render();
                document.documentElement.style.overflowY = 'visible';
                show(calendarViewTypeFilterContainer);
                hide(listViewTypeFilterContainer);
                hide(listViewYearFilterContainer);

                document.querySelectorAll('.fc-more-link').forEach(fcLink => {
                    fcLink.removeEventListener('click', handleFcMoreClick);
                    fcLink.addEventListener('click', handleFcMoreClick);
                });
            }
        });

        listViewToggle?.addEventListener('click', () => {
            if (listViewToggle.ariaExpanded !== 'true') {
                listViewToggle.ariaExpanded = 'true';
                listViewToggle.classList.add('on');

                calendarViewToggle.ariaExpanded = 'false';
                calendarViewToggle.classList.remove('on');

                hide(calendarView);
                show(listView);

                document.documentElement.style.removeProperty('overflow-y');
                hide(calendarViewTypeFilterContainer);
                show(listViewTypeFilterContainer);
                show(listViewYearFilterContainer);
            }
        });
    }

}

const handleFcMoreClick = (event: Event) => {
    const observer = new MutationObserver(mutationList => {
        for (const mutation of mutationList) {
            for (const node of mutation.addedNodes) {
                if (node.nodeType === 1 && (node as HTMLElement).classList.contains('fc-more-popover')) {
                    ((node as HTMLElement).querySelector('a') as HTMLAnchorElement | null)?.focus();
                    (node as HTMLElement).addEventListener('focusout', event => {
                        if (!event.relatedTarget || !node.contains(event.relatedTarget as Node)) {
                            (document.querySelector('.fc-popover-close') as HTMLSpanElement | null)?.click();
                            (event.target as HTMLAnchorElement).focus();

                            observer
                        }
                    });
                }
            }
        }
    })
    .observe(document.body, { childList: true, subtree: true });

    const fcMorePopver: HTMLElement | null = document.querySelector('.fc-more-popover');

    (fcMorePopver?.querySelector('.fc-more-popover a:first') as HTMLAnchorElement | null)?.focus();
    fcMorePopver?.addEventListener('focusout', event => {
        if (!fcMorePopver.contains(event.relatedTarget as Node)) {
            (document.querySelector('.fc-popover-close') as HTMLSpanElement | null)?.click();
            (event.target as HTMLAnchorElement).focus();
        }
    });
};